import { selectIsPremium, useSession } from './session';
import { useUI } from './ui';

export const FREE_RUNS_PER_DAY = 5;

const KEY = 'brassflows_scale_runs_v1';

// local calendar day, so the count resets at the player's midnight
const today = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const runsToday = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY));
    if (raw && raw.day === today()) return raw.count || 0;
  } catch (e) {
    // fall through to 0
  }
  return 0;
};

export const runsLeftToday = () => Math.max(0, FREE_RUNS_PER_DAY - runsToday());

// Premium players, and anyone whose login is still loading, are never counted or blocked
const isUnlimited = () => {
  const s = useSession.getState();
  return !s.ready || selectIsPremium(s);
};

// Call when a run actually starts
export const registerRun = () => {
  if (isUnlimited()) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ day: today(), count: runsToday() + 1 }));
  } catch (e) {
    // storage unavailable; the run just isn't counted
  }
};

// true = go ahead. Out of free runs: opens the pricing modal and returns false.
export const canStartRun = () => {
  if (isUnlimited() || runsLeftToday() > 0) return true;
  useUI
    .getState()
    .openPricing(`Free accounts get ${FREE_RUNS_PER_DAY} scale runs a day. Premium is unlimited.`);
  return false;
};